import React, { Fragment, useState } from "react";
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import { H3 } from "../../../AbstractElements";
import { X } from "react-feather";
import GroupForm from "../Forms/GroupForm";
import { defaultUserType } from "../../api/helper";

const AddGroupModal = (props) => {
    const [open, setOpen] = useState(props.value);
    const userType = sessionStorage.getItem('userType');

    const onClose = () => {
        setOpen(false);
        props.setOpenModal(false)
    }

    return (
        <Fragment>
            <Modal centered={true} isOpen={open} size='lg'>
                <ModalHeader style={{ display: 'flex' }}>
                    <H3 attrH3={{ className: 'modal-title-color' }}>New Group
                        <X className="x-button" onClick={onClose}/>
                    </H3>
                </ModalHeader>
                <ModalBody>
                    <GroupForm action={'Add'} cancel={onClose} navigateUrl={`${process.env.PUBLIC_URL}/${defaultUserType[userType]}/group-list`} asoOrgId={props.asoOrgId} setAdd={props.setAdd}/>
                </ModalBody>
            </Modal>
        </Fragment>
    )
}

export default AddGroupModal;